import React from 'react'
import Navbar from '../components/Navbar'
import ContactPage from '../components/ContactPage'
import Footer from '../components/Footer'
const Contact = () => {
  return (
    <div>
     <Navbar />
     <ContactPage />
     <Footer />
    </div>
  )
}

export default Contact
